export enum ObservationType {
    EMPTY_BOX = "Empty Box",
    PARTIAL_NEST = "Partial Nest",
    COMPLETE_NEST = "Complete Nest"
}